import React from 'react'
import './App.css'
import Header from '../header/Header'
import Main from '../main/Main'
import Footer from '../footer/Footer'

const App = () => (
  <div className="App">
    <div className="MainHeader">
      <Header />
    </div>
    <div className="MainContent">
      <Main />
    </div>
    <div className="MainFooter">
      <Footer />
    </div>
  </div>
)


export default App;



// WEBPACK FOOTER //
// ./src/components/app/App.js